import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = {
  key: 0,
  class: "loading-indicator",
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_5 = {
  key: 1,
  class: "error-message",
  style: {"text-align":"center","padding":"20px","color":"red"}
}
const _hoisted_6 = {
  key: 2,
  class: "glores-B-list-type1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "order-detail-modal-content",
  style: {"overflow-y":"auto","max-height":"calc(600px - 150px)"}
}
const _hoisted_9 = {
  key: 0,
  style: {"margin-top":"20px"}
}
const _hoisted_10 = {
  key: 1,
  style: {"margin-top":"20px","text-align":"center","color":"#888"}
}
const _hoisted_11 = {
  key: 2,
  style: {"margin-top":"20px"}
}
const _hoisted_12 = {
  key: 1,
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_13 = { style: {"width":"100%","text-align":"center"} }

import { ref, onMounted, h, computed, watch } from "vue";
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import {
  NDataTable,
  NButton,
  NSpace,
  useMessage,
  NModal,
  NDescriptions,
  NDescriptionsItem,
  NCard,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useRouter } from "vue-router";
import { getQuotationStatusString } from "@/composables/useOrderForm";
import { Order } from "@/model/order";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const getMyOrders = "getMyOrders";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrgOrderReqList',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const message = useMessage();
const router = useRouter();

watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

const pageLoading = ref(false);
const listLoading = ref(false);
const error = ref<string | null>(null);
const orders = ref<Order[]>([]);

const showOrderDetailModal = ref(false);
const selectedOrderDetail = ref<Order | null>(null);
const getCallApiCallable = getCallable("callApi");
const columns = computed(() => [
  {
    title: "신청일",
    key: "createdDate",
    render: (row: Order) =>
      common.getYYYYMMDD2(new Date(Number(row.createdDate))),
  },
  {
    title: "총 금액",
    key: "totalPrice",
    render: (row: Order) => `${(row.totalPrice || 0).toLocaleString()}원`,
  },
  {
    title: "상태",
    key: "status",
    render: (row: Order) => getQuotationStatusString(row.status),
  },
  {
    title: "관리",
    key: "actions",
    width: 100, // 버튼 두 개를 넣기 위해 너비 조정
    render(row: Order) {
      return h(
        NButton,
        {
          size: "small",
          type: "default",
          style: "margin-right: 6px;",
          onClick: () => viewOrderDetails(row),
        },
        { default: () => "상세보기" }
      ); // NSpace로 버튼들을 감싸서 반환
    },
  },
]);

const pagination = ref({ pageSize: 10 }); // 페이지네이션 설정

async function fetchUserOrders() {
  listLoading.value = true;
  error.value = null;
  try {
    const result = await getCallApiCallable(
      makeCallApiParam(getMyOrders, {
        type: constant.orderType.BODY,
        subType: constant.orderSubType.QUOTATION,
      })
    );
    orders.value = common.getItemListFromFunctionResult(result) as Order[];
  } catch (err: any) {
    console.error("사용자 견적 목록 로딩 실패:", err);
    error.value = "견적 목록을 불러오는데 실패했습니다.";
    orders.value = [];
  } finally {
    listLoading.value = false;
  }
}

function viewOrderDetails(order: Order) {
  selectedOrderDetail.value = order;
  showOrderDetailModal.value = true;
}

function gotoOrderProject(orderSK: string) {
  router.push({
    name: USER_ROUTES.Mypage.Order.Org.Project.Name,
    params: { SK: orderSK },
  });
}

function gotoOrderProjectDetail(orderSK: string) {
  router.push({
    name: USER_ROUTES.Mypage.Order.Org.Project.Detail.Name,
    params: { SK: orderSK },
  });
}

onMounted(() => {
  fetchUserOrders();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, pageLoading.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPageSidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("[기관] 진단신청"),
          _createElementVNode("span")
        ], -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "glores-B-list-h2" }, [
          _createElementVNode("div", { class: "h-left" })
        ], -1)),
        (listLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 진단신청 목록을 불러오는 중... "))
          : _createCommentVNode("", true),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        (!listLoading.value && !error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (orders.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(NDataTable), {
                    key: 0,
                    columns: columns.value,
                    data: orders.value,
                    pagination: pagination.value,
                    bordered: false,
                    "single-line": false
                  }, null, 8, ["columns", "data", "pagination"]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_7, _cache[3] || (_cache[3] = [
                    _createElementVNode("li", { class: "none-data" }, "등록된 진단신청이 없습니다.", -1)
                  ])))
            ]))
          : _createCommentVNode("", true),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "glores-B-paginate" }, [
          _createElementVNode("div", { class: "ui-pagenate" })
        ], -1))
      ])
    ]),
    _createVNode(_unref(NModal), {
      show: showOrderDetailModal.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showOrderDetailModal).value = $event)),
      preset: "card",
      style: {"width":"800px","max-width":"90vw","max-height":"600px"},
      title: "견적 상세 정보",
      bordered: true,
      closable: true,
      "mask-closable": true,
      onAfterLeave: _cache[2] || (_cache[2] = ($event: any) => (selectedOrderDetail.value = null))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(NButton), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showOrderDetailModal.value = false))
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("닫기")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (selectedOrderDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(NDescriptions), {
                "label-placement": "left",
                bordered: "",
                column: 2,
                size: "small",
                title: "진단신청 정보"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NDescriptionsItem), { label: "기관명" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedOrderDetail.value.client?.name || "N/A"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDescriptionsItem), { label: "총 금액" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((selectedOrderDetail.value.totalPrice || 0).toLocaleString()) + "원", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getQuotationStatusString)(selectedOrderDetail.value.status)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDescriptionsItem), { label: "생성일" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedOrderDetail.value.createdDate
                ? common.getYYYYMMDD2(
                    new Date(Number(selectedOrderDetail.value.createdDate))
                  )
                : "N/A"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDescriptionsItem), { label: "견적서 수신자" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedOrderDetail.value.receiver_email || "N/A"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (
            selectedOrderDetail.value.products &&
            selectedOrderDetail.value.products.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[7] || (_cache[7] = _createElementVNode("h4", { style: {"margin-bottom":"10px","font-size":"1.1em"} }, "신청 상품 목록", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOrderDetail.value.products, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.SK || `product-${index}`,
                        class: "product-item-card-modal"
                      }, [
                        _createVNode(_unref(NDescriptions), {
                          "label-placement": "top",
                          bordered: "",
                          column: 3,
                          size: "small"
                        }, {
                          header: _withCtx(() => [
                            _createTextVNode(" 상품 " + _toDisplayString(index + 1) + ": " + _toDisplayString(item.name), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(NDescriptionsItem), { label: "단가" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString((item.unit_price || 0).toLocaleString()) + "원 ", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(NDescriptionsItem), { label: "수량" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.quantity), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(NDescriptionsItem), { label: "공급가액" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString((item.supply_price || 0).toLocaleString()) + "원 ", 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, " 진단신청에 포함된 상품이 없습니다. ")),
              (selectedOrderDetail.value.payment_method)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[9] || (_cache[9] = _createElementVNode("h4", { style: {"margin-bottom":"10px","font-size":"1.1em"} }, "결제 정보", -1)),
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 1,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), { label: "결제 방법" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrderDetail.value.payment_method.type === "bank_deposit"
                  ? "계좌이체"
                  : selectedOrderDetail.value.payment_method.type || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "입금자명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrderDetail.value.payment_method.deposit_name || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "입금 예정일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrderDetail.value.payment_method.bank_date
                  ? common.getYYYYMMDD2(
                      new Date(selectedOrderDetail.value.payment_method.bank_date)
                    )
                  : "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "결제 계좌" }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode(" 우리은행 : 1005-104-783814, 예금주: (주)코코랩 ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, " 상세 정보를 불러오는 중이거나, 선택된 진단신청이 없습니다. "))
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})